import React from 'react';
import PropTypes from 'prop-types';

import {Commands as ModuleCommands} from 'views/module';

const SlashCommands = (props) => {
  const {clientBackend, clientData, clientRn} = props;

  const slashCommandProps = React.useMemo(() => {
    const primaryRelationship = Object.values(clientData?.relationships ?? {}).find((relationship) => {
      return Number(relationship?.priority) === 1;
    }) || null;
    const relationshipRn = primaryRelationship?.relationshipRn || null;
    const email = primaryRelationship?.contacts?.find((contact) => {
      return contact?.type === 'Email';
    })?.detail || '';
    const sms = primaryRelationship?.contacts?.find((contact) => {
      return contact?.type === 'Phone';
    })?.detail || '';

    const [firstName, ...lastNameParts] = clientData.clientName.split(' ');

    return {
      communicationTarget: {
        email,
        sms,
        sendEmail: async (emailData, onSuccess, onError=()=>undefined) => {
          if (!relationshipRn) {
            onError();
            return null;
          }

          return clientBackend.messages.sendEmail(relationshipRn, emailData, onSuccess, onError);
        },
        sendSms: async (smsData, requester, onSuccess, onError=()=>undefined) => {
          if (!relationshipRn) {
            onError();
            return null;
          }

          return clientBackend.messages.sendSms(
              relationshipRn,
              smsData.message,
              requester?.email,
              smsData.from,
              onSuccess,
              onError,
          );
        },
      },
      resources: [
        {type: 'CLIENT', rn: clientRn, firstName, lastName: lastNameParts.join(' ')},
      ],
      playbook: {
        execute: async (playbookRn, primaryResourceRn) => {
          await clientBackend.playbooks.execute(playbookRn, primaryResourceRn);
        },
      },
    };
  }, [clientBackend, clientData, clientRn]);

  return (
    <ModuleCommands
      {...slashCommandProps}
    />
  );
};

SlashCommands.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
  clientRn: PropTypes.string.isRequired,
};

export default React.memo(SlashCommands);
